import React from 'react'
import { connect } from 'react-redux'
import { getFormValue, hasChangedValues, changeItemsValue } from '../../public/utility/formValues'
import { getListItems, addListItem, deleteListItem } from '../../public/utility'

class AccountOpenDiv extends React.Component {
	state = {}
	componentDidMount = () => {
		const { id } = this.props
		Tyan.doPostEvent({
			event: 'GetAccountOpen',
			data: { id },
			onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
					return
				}
				this.setState({ initValues基本信息, optionsParas })
			}
		})
	}

	handlerSave = () => {
		const { changedValues基本信息, } = this.state
		const { onSave, onClose, id } = this.props
		Tyan.doPostEvent({
			event: 'SaveAccountOpen',
			data: { id, changedValues基本信息 },
			onEnd: ({ errorMessage }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
					return
				}
				Ext.toast('保存成功')
				onClose && onClose()
				onSave && onSave()
			}
		})
	}

	handlerDelete = () => {
		const { onSave, onClose, id } = this.props
		Tyan.pubForm.showConfirm('确定要删除？', () =>
			Tyan.doPostEvent({
				event: 'DeleteAccountOpen',
				data: { id },
				onEnd: ({ errorMessage }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
						return
					}
					Ext.toast('删除成功')
					onClose && onClose()
					onSave && onSave()
				}
			}))
	}

	handlerClose = () => {
		const { onClose } = this.props
		if (!this.bChanged()) {
			onClose && onClose()
			return
		}
		Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
	}

	bChanged = () => {
		return hasChangedValues(this)
	}

	ChangeBankName = (v) => {
		// const 申请时间 = getFormValue(this, '基本信息', '申请时间')
		// const 币别 = getFormValue(this, '费用明细', `费用明细[${id}].币别`)

		Tyan.doPostEvent({
			event: 'GetBankNameInfo',
			data: { bankName: v },
			onEnd: ({ errorMessage, initValues }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					changeItemsValue(this, '基本信息', [`开户行英文名称`, `开户行中文地址`, `开户行英文地址`], [initValues.开户行英文名称, initValues.开户行中文地址, initValues.开户行英文地址])
				}
			}
		})
	}

	AddCurrency = () => {
		addListItem(this, {}, '基本信息', '开户账号币别')
	}

	DeleteCurrency = (id) => {
		Tyan.pubForm.showConfirm('确定要删除？', () =>
			deleteListItem(this, '基本信息', '开户账号币别', id)
		)
	}

	fieldset基本信息 = () => {
		const { optionsParas } = this.state
		return [
			{ _select: '开票公司', minWidth: '45%', required: true, editable: true, forceSelection: true, },
			{ _date: '启用日期', minWidth: '45%', required: true },
			{ _select: '开户行中文名称', minWidth: '45%', required: true, editable: true, forceSelection: false, onChange: (v) => this.ChangeBankName(v) },
			{ _text: '开户行英文名称', minWidth: '45%', },
			{ _text: '开户行中文地址', minWidth: '45%', },
			{ _text: '开户行英文地址', minWidth: '45%', },
			{ _date: '停用日期', minWidth: '45%', maxWidth: '50%' },
			{
				_grid: '', name: '开户账号币别', rowNumbers: true, minRows: 3, minWidth: '90%',
				columns: [
					{ _text: '币别<font style="color:red;">*</font>', name: '币别', minWidth: 250, flex: 2, edit: { options: optionsParas.币别 } },
					{ _text: '账号', minWidth: 250, flex: 2, edit: true, },
					{ _text: '银行行号', minWidth: 150, flex: 1, edit: true, },
					{ _text: 'Swift Code', name: '银行代码', minWidth: 150, flex: 1, edit: true, },
					{
						_buttons: [
							{ _button: ``, icon: 'trash-o', ui: 'decline', handler: (data, record) => this.DeleteCurrency(record.id) }
						], width: '101px', margin: 0, align: 'right'
					},
				],
				buttons: [
					{ _button: '添加...', icon: 'plus', handler: this.AddCurrency }
				],
			},
		]
	}

	render() {
		const { showMessage: Message, showBody: Body, id } = this.props
		const { initValues基本信息 } = this.state
		if (!initValues基本信息) return <Message text={'请稍等 ...'} />
		const bChanged = this.bChanged()
		return <Body data={this} maxWidth="1200" minWidth="800"
			controls={
				[
					{ _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !bChanged },
					{ _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0, handler: this.handlerDelete },
					{ _button: bChanged ? '取消' : '关闭', icon: 'close', handler: this.handlerClose },
				]}
			fieldsets={
				[
					{ title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
				]}
		/>
	}
}

export default connect()(AccountOpenDiv)